import { IField } from '@eventr/common'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../../state/bound.store'
import { useEditSectionContext } from '../editSectionProvider'
import { EditMembersItemPage } from './EditMembersItemPage'
import { EditSubItem } from './editSubItem'
import { ListSubPage } from './listPage'
export const SubPageFinder = () => {
    const { section } = useEditSectionContext()
    const { fields } = useBoundStore(
        useShallow((s) => {
            return {
                fields: s.fields,
            }
        })
    )
    const { idItem, idSubPage, idSubItem } = useParams<{
        idItem: string
        idSubPage: string
        idSubItem: string
    }>()

    const subPage = useMemo(() => {
        if (section === undefined) {
            return undefined
        }
        return section.properties.mobileEditFieldOptions.subPages[idSubPage]
    }, [section, idSubPage])

    if (subPage === undefined) {
        return <div />
    }

    if (subPage.type === 'list') {
        const fieldInfo = fields?.find((field: IField) => {
            return field.id.toString() === subPage.fieldId.toString()
        })
        return <ListSubPage field={fieldInfo} subPage={subPage} _id={idItem} />
    }

    if (subPage.type === 'editSubItem') {
        return (
            <EditSubItem id={section.name} subPage={subPage} _id={idSubItem} />
        )
    }
    if (subPage.type === 'editMembersItem') {
        return <EditMembersItemPage subPage={subPage} _id={idSubItem} />
    }
}
